import { useSearchParams } from 'react-router-dom'
import OptionItemForm from '../components/OptionItemForm'

const CreateOptionItemPage = () => {
  const [searchParams] = useSearchParams()
  const defaultGroupId = searchParams.get('groupId') ? parseInt(searchParams.get('groupId')!) : undefined

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900">Create Option Item</h1>
        <p className="mt-1 text-sm text-gray-500">
          Create a new option item for product customization
        </p>
      </div>
      
      <OptionItemForm defaultGroupId={defaultGroupId} />
    </div>
  )
}

export default CreateOptionItemPage
